import React from "react";

const GoogleSheetsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_388)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_368_388",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 1,
  width: 12,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4718 1.90506H5.21665C4.60953 1.90506 4.11279 2.4018 4.11279 3.00892V16.9911C4.11279 17.5982 4.60953 18.0949 5.21665 18.0949H14.7834C15.3905 18.0949 15.8872 17.5982 15.8872 16.9911V6.32048L11.4718 1.90506Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_368_388)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4718 1.90506H5.21665C4.60953 1.90506 4.11279 2.4018 4.11279 3.00892V16.9911C4.11279 17.5982 4.60953 18.0949 5.21665 18.0949H14.7834C15.3905 18.0949 15.8872 17.5982 15.8872 16.9911V6.32048L13.3116 4.48072L11.4718 1.90506Z",
  fill: "#0F9D58"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask1_368_388",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 1,
  width: 12,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4718 1.90506H5.21665C4.60953 1.90506 4.11279 2.4018 4.11279 3.00892V16.9911C4.11279 17.5982 4.60953 18.0949 5.21665 18.0949H14.7834C15.3905 18.0949 15.8872 17.5982 15.8872 16.9911V6.32048L11.4718 1.90506Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_368_388)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.0564 9.81602V15.1513H12.9436V9.81602H7.0564ZM9.63206 14.4154H7.7923V13.4955H9.63206V14.4154ZM9.63206 12.9436H7.7923V12.0237H9.63206V12.9436ZM9.63206 11.4718H7.7923V10.5519H9.63206V11.4718ZM12.2077 14.4154H10.368V13.4955H12.2077V14.4154ZM12.2077 12.9436H10.368V12.0237H12.2077V12.9436ZM12.2077 11.4718H10.368V10.5519H12.2077V11.4718Z",
  fill: "#F1F1F1"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask2_368_388",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 1,
  width: 12,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4718 1.90506H5.21665C4.60953 1.90506 4.11279 2.4018 4.11279 3.00892V16.9911C4.11279 17.5982 4.60953 18.0949 5.21665 18.0949H14.7834C15.3905 18.0949 15.8872 17.5982 15.8872 16.9911V6.32048L11.4718 1.90506Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_368_388)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.7947 5.99761L15.8872 10.0892V6.32048L11.7947 5.99761Z",
  fill: "url(#paint0_linear_368_388)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask3_368_388",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 1,
  width: 12,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4718 1.90506H5.21665C4.60953 1.90506 4.11279 2.4018 4.11279 3.00892V16.9911C4.11279 17.5982 4.60953 18.0949 5.21665 18.0949H14.7834C15.3905 18.0949 15.8872 17.5982 15.8872 16.9911V6.32048L11.4718 1.90506Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3_368_388)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4718 1.90506V5.21663C11.4718 5.82651 11.9658 6.32048 12.5757 6.32048H15.8872L11.4718 1.90506Z",
  fill: "#87CEAC"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask4_368_388",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 1,
  width: 12,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4718 1.90506H5.21665C4.60953 1.90506 4.11279 2.4018 4.11279 3.00892V16.9911C4.11279 17.5982 4.60953 18.0949 5.21665 18.0949H14.7834C15.3905 18.0949 15.8872 17.5982 15.8872 16.9911V6.32048L11.4718 1.90506Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask4_368_388)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.21665 1.90506C4.60953 1.90506 4.11279 2.40179 4.11279 3.00892V3.1009C4.11279 2.49378 4.60953 1.99705 5.21665 1.99705H11.4718V1.90506H5.21665Z",
  fill: "white",
  fillOpacity: 0.2
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask5_368_388",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 1,
  width: 12,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4718 1.90506H5.21665C4.60953 1.90506 4.11279 2.4018 4.11279 3.00892V16.9911C4.11279 17.5982 4.60953 18.0949 5.21665 18.0949H14.7834C15.3905 18.0949 15.8872 17.5982 15.8872 16.9911V6.32048L11.4718 1.90506Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask5_368_388)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.7834 18.003H5.21665C4.60953 18.003 4.11279 17.5062 4.11279 16.8991V16.9911C4.11279 17.5982 4.60953 18.095 5.21665 18.095H14.7834C15.3905 18.095 15.8872 17.5982 15.8872 16.9911V16.8991C15.8872 17.5062 15.3905 18.003 14.7834 18.003Z",
  fill: "#263238",
  fillOpacity: 0.2
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask6_368_388",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 1,
  width: 12,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4718 1.90506H5.21665C4.60953 1.90506 4.11279 2.4018 4.11279 3.00892V16.9911C4.11279 17.5982 4.60953 18.0949 5.21665 18.0949H14.7834C15.3905 18.0949 15.8872 17.5982 15.8872 16.9911V6.32048L11.4718 1.90506Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask6_368_388)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5757 6.32048C11.9658 6.32048 11.4718 5.82651 11.4718 5.21663V5.30862C11.4718 5.9185 11.9658 6.41247 12.5757 6.41247H15.8872V6.32048H12.5757Z",
  fill: "#263238",
  fillOpacity: 0.1
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.4718 1.90506H5.21665C4.60953 1.90506 4.11279 2.4018 4.11279 3.00892V16.9911C4.11279 17.5982 4.60953 18.0949 5.21665 18.0949H14.7834C15.3905 18.0949 15.8872 17.5982 15.8872 16.9911V6.32048L11.4718 1.90506Z",
  fill: "url(#paint1_radial_368_388)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_368_388",
  x1: 13.8412,
  y1: 6.34892,
  x2: 13.8412,
  y2: 10.0898,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#263238",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#263238",
  stopOpacity: 0.02
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_368_388",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.48581 2.22687) scale(18.9861)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_388"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12.1891,
  height: 16.6667,
  fill: "white",
  transform: "translate(3.90552 1.66667)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleSheetsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;